import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { Spinner as Spinner$1 } from 'reactstrap';
import classNames from 'classnames';

var Spinner = function (_a) {
    var className = _a.className, color = _a.color, label = _a.label, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.labelDelay, labelDelay = _c === void 0 ? 5000 : _c, _d = _a.type, type = _d === void 0 ? 'border' : _d, props = __rest(_a, ["className", "color", "label", "size", "labelDelay", "type"]);
    var _e = useState(false), showLabel = _e[0], setShowLabel = _e[1];
    useEffect(function () {
        if (label) {
            setTimeout(function () {
                setShowLabel(true);
            }, labelDelay);
        }
    }, []);
    var reactstrapSpinner = (jsx(Spinner$1, __assign({ className: classNames(className, size && size !== 'md' ? "spinner-".concat(type, "-").concat(size) : '', color === 'brand' ? 'text-brand-primary' : color && "text-".concat(color)), type: type, "data-testid": "spinner" }, props)));
    return label ? (jsxs("div", __assign({ className: "text-center" }, { children: [jsx("div", __assign({ className: "mb-3" }, { children: reactstrapSpinner })), jsx("p", __assign({ className: classNames('spinner-label', !showLabel && 'opacity-0'), "data-testid": "spinner-label" }, { children: label }))] }))) : (reactstrapSpinner);
};

export { Spinner };
